import T6 from '../../components/ExcerciseTypes/TypeIn/T6'
import DesignUnderLine from '../../components/ExcerciseTypes/Design/DesignUnderLine'

const json = {
	1: {
		// Exercise num
		unit: 'Unit 10',
		id: '4WB-U10-P70-E1',
		audio: '',
		video: '',
		component: T6,
		maxLength: 100,
		exerciseKey: 'img/FriendsPlus/Page70/E1/Key/E1answerKey.png',
		inputSize: 300,
		checkUppercase: true,
		isHiddenCheck: true,
		titleQuestion: [
			{
				num: '1',
				title: 'Look and number.',
				color: '#23408f',
			},
		],
		questionImage: [],
		stylesTextInput: {
			background: 'none',
			borderBottom: 'none',

			fontSize: 24,
			height: 28,
			// textTransform: 'uppercase',
			textAligh: 'center',
			width: 35,
		},
		maxLength: 1,
		questions: [
			{
				title: `
		<div style=" position: relative ">
		 <img src='img/FriendsPlus/Page70/E1/1.jpg' width='95%'>

		 <div style=" position: absolute; top: 25px; left: 83px; "><input id='0'</input></div>
     <div style=" position: absolute; top: 37px; left: 422px; "><input id='1'</input></div>
		 <div style=" position: absolute; top: 153px; left: 267px; "><input id='2'</input></div>
		 <div style=" position: absolute; top: 151px; left: 525px; "><input id='3'</input></div>
     <div style=" position: absolute; top: 95px; left: 921px; "><input id='4'</input></div>
		</div>
        `,
				answer: ['4', '5', '6', '2', '3'],
			},
		],
	},
	2: {
		unit: 'Unit 10',
		id: '4WB-U10-P70-E2',
		audio: '',
		video: '',
		component: T6,
		exerciseKey: 'img/FriendsPlus/Page70/E2/Key/E2answerKey.png',
		titleQuestion: [
			{
				num: '2',
				title: `
				Look at the pictures and write.
			  `,
				color: '#23408f',
			},
		],
		hintBox: [],
		titleImage: '',
		questionImage: [],
		inputSize: 50,
		maxLength: 40,
		stylesTextInput: {
			background: 'none',
			borderBottom: 'none',
			fontSize: 20,
			height: 24,
			width: 280,
			textAlign: 'left',
		},
		maxLength: 7,
		textAlign: 'center',
		checkUppercase: true,
		isHiddenCheck: true,
		questions: [
			{
				title: `
					<div style=" position: relative ">
            <img src='img/FriendsPlus/Page70/E2/1.jpg' style='width: 24cm; height: 13cm'>
            <div style=" position: absolute; top: 200px; left: 496px; "><input id='0'></input></div>
            <div style=" position: absolute; top: 442px; left: 7px; "><input id='1'></input></div>
            <div style=" position: absolute; top: 442px; left: 440px; "><input id='2'></input></div>
					</div>
				
			  
			  `,
				answer: [
					'They like fishing',
					'They like playing basketball',
					'They like reading comics',
				],
			},
		],
	},
}

export default json
